import {
  createReqConsts,
  createActions,
  createReqWatcher,
  makePaginationReducer,
} from '../../../utils/redux';
import { handleUpdateStatusSurveyInAppointmentDetails } from '../../../components/Healthboard/utils/handleUpdateStateWithCompleteSurvey';
import { handleUpdateStateWithAcceptedConsent } from '../../../components/Healthboard/utils/handleUpdateStateWithAcceptedConsent';
import { handleUpdateStateWithUploadDoc } from '../../../components/Healthboard/utils/handleUpdateStateWithUploadDoc';
import { handleUpdateStateWithDeleteDoc } from '../../../components/Healthboard/utils/handleUpdateStateWithDeleteDoc';
import { findAndReplace } from '../../../utils/arrayModify';
import { APPOINTMENT_DETAILS_TYPES } from '../appointment-details';
import { makeVirtualAppointmentListReqConfig } from './appointment-req-config';
import { consts as UPLOAD_DOCUMENT_CONST } from './upload-document-req';
import { consts as DELETE_DOCUMENT } from './delete-document-req';
import { consts as EDIT_PAYMENT_CONST } from './edit-payment-req';
import { consts as SURVEY_COMPLETIONS } from '../../surveys/upcoming-survey-completions';
import { consts as SIGN_CONSENT_APPOINTMENT } from './sign-appointment-consent-req';
import { consts as MANAGE_PENDING_APPOINTMENT } from './manage-pending-request';
import { consts as CANCEL_OFFICE_VISIT } from './cancel-appointment-req';

const requestOptions = makeVirtualAppointmentListReqConfig([
  {
    type: 'payload.query',
    queryParameter: 'scope',
    value: 'upcoming_list',
  },
]);

export const consts = createReqConsts(
  'health-board',
  'upcoming-virtual-appointment-list-req',
  ['LOAD_MORE'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'health-board',
  'upcoming-virtual-appointment-list-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
  true,
);

const reducer = makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'appointmentsCount',
});

export default (state, action) => {
  switch (action.type) {
    case UPLOAD_DOCUMENT_CONST.SUCCEED: {
      return handleUpdateStateWithUploadDoc(state, action);
    }

    case EDIT_PAYMENT_CONST.SUCCEED: {
      const target = state.list.find(({ id }) => action.payload.id === id);
      return {
        ...state,
        list: findAndReplace(state.list, {
          ...target,
          copay: action.payload.copay,
        }),
      };
    }

    case MANAGE_PENDING_APPOINTMENT.SUCCEED: {
      const target = state.list.find(({ id }) => action.payload.id === id);
      if (target) {
        return {
          ...state,
          list: findAndReplace(state.list, {
            ...target,
            status: action.payload.status,
          }),
        };
      }
      return {
        ...state,
      };
    }

    case APPOINTMENT_DETAILS_TYPES.REPLACE_APPOINTMENT: {
      return {
        ...state,
        list: findAndReplace(state.list, action.payload),
      };
    }

    case SIGN_CONSENT_APPOINTMENT.SUCCEED: {
      return handleUpdateStateWithAcceptedConsent(state, action);
    }

    case APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT:
    case CANCEL_OFFICE_VISIT.SUCCEED: {
      const count = state.count - 1;
      return {
        ...state,
        count: count >= 0 ? count : 0,
        list: state.list.filter(({ id }) => id !== action.payload.id),
      };
    }

    case SURVEY_COMPLETIONS.SUCCEED: {
      return handleUpdateStatusSurveyInAppointmentDetails(state, action);
    }

    case DELETE_DOCUMENT.UPDATE: {
      return handleUpdateStateWithDeleteDoc(state, action);
    }

    default:
      return reducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/virtual-appointments-upcomming-req.js